// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const nid: CountryValidator<"IR"> = createValidator(
  "ir.nid",
  101,
);

export default nid;
export const compact = nid.compact;
export const format = nid.format;
export const validate = nid.validate;
export const generate = (): string =>
  nid.generate?.() ??
  (() => {
    throw new Error(
      "Validator ir.nid cannot generate values",
    );
  })();
